import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";

// Shared shell for legal pages (Impressum / Datenschutz)
export const LegalShell = ({ kicker, title, children }) => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="lx-noise relative overflow-hidden">
      <div className="lx-hero-ambient absolute inset-0 -z-10 opacity-60" />
      <div className="mx-auto max-w-3xl px-4 pb-24 pt-28 sm:px-6 sm:pt-32 lg:px-8 lg:pt-40">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="lx-navlink inline-flex items-center gap-2 font-mono-lx text-xs uppercase tracking-[0.18em]"
        >
          <ArrowLeft size={14} /> Zurück zur Startseite
        </Link>

        <motion.div variants={stagger} initial="hidden" animate="show" className="mt-8">
          <motion.div variants={fadeUp} className="lx-kicker mb-3">
            {kicker}
          </motion.div>
          <motion.h1
            variants={fadeUp}
            className="font-display text-3xl font-semibold tracking-tight text-[color:var(--lx-text)] sm:text-4xl"
          >
            {title}
          </motion.h1>
          <motion.div variants={fadeUp} className="lx-legal mt-8">
            {children}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

// Small helpers for consistent legal typography
export const LegalSection = ({ heading, children }) => (
  <section className="mb-8">
    {heading && (
      <h2 className="mb-2 font-display text-lg font-semibold text-[color:var(--lx-text)]">
        {heading}
      </h2>
    )}
    <div className="space-y-2 text-sm leading-relaxed text-[color:var(--lx-text-2)] sm:text-base">
      {children}
    </div>
  </section>
);
